import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function pinIcon(color, label) {
  return L.divIcon({
    className: "",
    html: `<div style="display:flex;flex-direction:column;align-items:center">
      <div style="background:${color};width:28px;height:28px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 4px 10px rgba(0,0,0,.25);border:2px solid #fff"></div>
      <span style="margin-top:2px;background:#fff;color:#1A1D20;font:700 10px Nunito,sans-serif;padding:1px 6px;border-radius:9px;box-shadow:0 2px 6px rgba(0,0,0,.15)">${label}</span>
    </div>`,
    iconSize: [28, 40],
    iconAnchor: [14, 34],
  });
}

const runnerIcon = pinIcon("#FF7A59", "Runner");
const destIcon = pinIcon("#66C2A5", "Drop-off");

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) {
      map.setView(points[0], 15, { animate: true });
    } else if (points.length >= 2) {
      map.fitBounds(points, { padding: [50, 50], maxZoom: 16, animate: true });
    }
  }, [JSON.stringify(points)]); // eslint-disable-line
  return null;
}

export function TrackMap({ runner, dest }) {
  const points = [];
  if (runner) points.push([runner.lat, runner.lng]);
  if (dest) points.push([dest.lat, dest.lng]);
  const center = runner ? [runner.lat, runner.lng] : dest ? [dest.lat, dest.lng] : [40.73, -73.99];

  return (
    <MapContainer center={center} zoom={14} scrollWheelZoom={false}
      style={{ height: "320px", width: "100%", borderRadius: "1.25rem", zIndex: 0 }}>
      <TileLayer
        attribution='&copy; OpenStreetMap'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {dest && <Marker position={[dest.lat, dest.lng]} icon={destIcon} />}
      {runner && <Marker position={[runner.lat, runner.lng]} icon={runnerIcon} />}
      {runner && dest && (
        <Polyline positions={[[runner.lat, runner.lng], [dest.lat, dest.lng]]}
          pathOptions={{ color: "#FF7A59", weight: 4, dashArray: "8 10", opacity: 0.8 }} />
      )}
      <FitBounds points={points} />
    </MapContainer>
  );
}
